module.exports = __webpack_public_path__ + "static/media/botton-sm-next.2699a821.svg";